import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  IconButton,
  Paper,
  Step,
  StepLabel,
  Stepper,
  TextField,
  Typography
} from "@mui/material";
import React, { useEffect, useState } from "react";
import toast from 'react-hot-toast';
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../context";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import apiService from "../../services/api-service";

let filesContent;

const ConcreteCastingRegistrationAdd = () => {
  const authContext = React.useContext(AuthContext);
  const navigate = useNavigate()
  const {id} = useParams()
  const [activeStep, setActiveStep] = useState(0)
  const [formData, setFormData] = useState({
    processing_name: "",
    steel_type: "",
    steel_withdrawal_report: "",
    number_of_samples: 1,
    file: null,
    url: null,
    samples: [{ sample_identification: "", description: "", diameter: "", position: "", required_test: "" }],
  })
  const [fieldErrors, setFieldErrors] = useState({})
  const [loading, setLoading] = useState(false)
  const [reportOptions, setReportOptions] = useState([])

  useEffect(() => {
    if (id) {
      apiService
        .get("/steel-withdrawal-registration-managment/" , {id: id}, {} )
        .then((response) => {
          debugger
          if (response) {
            setFormData(response)
          }
        })
        .catch((error) => {
          handleSetNotification('Errore durante la chiamata al server, codice d\'errore #08514262429906', 'error');
        })
    }
  }, [id])

  const handleSetNotification = (msg, severityType) => {
    if (severityType === 'success') {
      toast.success(msg, {id: 'steel-withdrawal-registration-add-toast'});
    } else {
      toast.error(msg, {id: 'steel-withdrawal-registration-add-toast'});
    }
  }

  function getReportOptions() {
    apiService.get("/steel-withdrawal-report-managment/get-option/", {id_area: localStorage.getItem("areaSelected")}, {} )
      .then((response) => {
        if (response)
          setReportOptions(response)
      })
      .catch((error) => {
        handleSetNotification('Errore durante la chiamata al server, codice d\'errore #08514262429906', 'error');
      })
  }

  useEffect(() => {
    getReportOptions()
  }, []);

   const handleInputChange = (name, value) => {
    setFormData((prevData) => ({ ...prevData, [name]: value }))
    setFieldErrors((prevErrors) => ({ ...prevErrors, [name]: false }))

    if (name === "number_of_samples") {
      updateSamplesArray(value)
    }
  }

  const updateSamplesArray = (newNumberOfSamples) => {
    setFormData((prevData) => {
      const currentSamples = [...prevData.samples]
      if (newNumberOfSamples === "" || isNaN(newNumberOfSamples)) {
        // Keep existing cubes in memory, but don't display them
        return { ...prevData, number_of_samples: newNumberOfSamples }
      } else {
        const numSamples = Number.parseInt(newNumberOfSamples, 10)
        if (numSamples > currentSamples.length) {
          // Add new cubes
          const newCubes = Array(numSamples - currentSamples.length)
            .fill()
            .map(() => ({ sample_identification: "", description: "", diameter: "", position: "", required_test: "" }))
          return {
            ...prevData,
            number_of_samples: numSamples,
            samples: [...currentSamples, ...newCubes],
          }
        } else if (numSamples < currentSamples.length) {
          // Remove excess cubes
          return {
            ...prevData,
            number_of_samples: numSamples,
            samples: currentSamples.slice(0, numSamples),
          }
        }
        // If the number is the same, no change is needed
        return { ...prevData, number_of_samples: numSamples }
      }
    })
  }

  const handleSampleInputChange = (index, field ,value) => {
    const newSamples = [...formData.samples]
    newSamples[index] = { ...newSamples[index], [field]: value }
    setFormData((prevData) => ({ ...prevData, samples: newSamples }))
  }

  const validateStep = (step) => {
    const errors = {}
    if (step === 0) {
      if (!formData.processing_name) errors.processing_name = true
      if (!formData.steel_type) errors.steel_type = true
      if (!formData.steel_withdrawal_report) errors.steel_withdrawal_report = true
      if (!formData.file && !formData.url) errors.file = true
    } else if (step === 1) {
      if (!formData.number_of_samples || formData.number_of_samples < 1) errors.number_of_samples = true
      formData.samples.forEach((sample, index) => {
        if (!sample.sample_identification ) errors[`cube_${index}_sample_identification`] = true
        if (!sample.description ) errors[`cube_${index}_description`] = true
        if (!sample.diameter ) errors[`cube_${index}_diameter`] = true
        if (!sample.position ) errors[`cube_${index}_position`] = true
        if (!sample.required_test ) errors[`cube_${index}_required_test`] = true
      })
    }
    setFieldErrors(errors)
    return Object.keys(errors).length === 0
  }

  const handleNext = () => {
    if (validateStep(activeStep)) {
      setActiveStep((prevStep) => prevStep + 1)
    } else {
      const errorFields = Object.keys(fieldErrors).join(", ")
      handleSetNotification(`Compila tutti i campi prima di procedere`, "error")
    }
  }

  const handleBack = () => {
    setActiveStep((prevStep) => prevStep - 1)
  }

  const handleSubmit = async () => {
    if (validateStep(1)) {
      setLoading(true)
      try {
        if (formData.file) {
          formData.file.content = filesContent;
        }
        await apiService.post(
          "/steel-withdrawal-registration-managment/",
          {},
          formData,
        )
        handleSetNotification("Verbale creato con successo", "success")
        navigate("/steel-withdrawal-registration-managment/")
      } catch (error) {
        handleSetNotification("Errore durante la chiamata al server, codice d'errore #08514262429906", "error")
      } finally {
        setLoading(false)
      }
    } else {
      const errorFields = Object.keys(fieldErrors).join(", ")
      handleSetNotification(`Compila tutti i campi prima di procedere`, "error")
    }
  }

  const handleFileChange = (event) => {
    if (!event.target.files) return;

    const filePromise = new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const fileObj = {
          name: event.target.files[0].name,
          type: event.target.files[0].type,
          size: event.target.files[0].size,
          modified: event.target.files[0].lastModified,
          content: null
        };
        const contentObj = reader.result;

        filesContent = contentObj;

        resolve(fileObj);
      };
      reader.readAsDataURL(event.target.files[0]);
    });

    Promise.resolve(filePromise).then((processedFile) => {
      setFormData((prevDoc) => ({ ...prevDoc, file: processedFile, url: null }));
      setFieldErrors((prevErrors) => ({ ...prevErrors, file: false }));
    });
  };

const handleRemoveSample = (indexToRemove) => {
  setFormData((prevData) => ({
    ...prevData,
    number_of_samples: prevData.number_of_samples - 1,
    samples: prevData.samples.filter((_, index) => index !== indexToRemove),
  }))
}

const handleDownload = () => {
    if (formData.url) {
      window.open(formData.url, '_blank');
    }
  };

  const renderStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <>
            <Box sx={{mb: 2}}>
                <input
                  accept="*/*"
                  style={{display: 'none'}}
                  id="raised-button-file"
                  type="file"
                  onChange={handleFileChange}
                />
                <label htmlFor="raised-button-file">
                  <Button
                    variant="contained"
                    component="span"
                    sx={{
                      color: 'white!important',
                      borderColor: fieldErrors.file ? 'red' : 'primary.main',
                      '&:hover': {
                        borderColor: fieldErrors.file ? 'red' : 'primary.dark',
                      },
                    }}
                  >
                    {formData.file || formData.url ? 'Cambia DDT' : 'Carica DDT'}
                  </Button>
                </label>
                {(formData.file || formData.url) && (
                  <Typography variant="body2" sx={{mt: 1}}>
                    {formData.file ? formData.file.name : 'File già caricato'}
                  </Typography>
                )}
                {(id && formData.file && formData.url) || formData.url ? (
                  <Button
                    startIcon={<DownloadIcon/>}
                    variant="contained"
                    color="primary"
                    sx={{
                      marginBottom: "30px",
                      color: 'white!important',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px'
                    }} onClick={handleDownload}
                  >
                    Scarica
                  </Button>
                ) : null}
                {fieldErrors.file && (
                  <Typography color="error" variant="caption" sx={{mt: 1, display: 'block'}}>
                    File richiesto
                  </Typography>
                )}
              </Box>
            <TextField
              fullWidth
              label="Nome lavorazione"
              name="processing_name"
              value={formData.processing_name}
              onChange={(e) => handleInputChange("processing_name", e.target.value)}
              required
              error={fieldErrors.processing_name}
              sx={{ mb: 2 }}
            />
            <TextField
              fullWidth
              label="Tipologia acciaio"
              name="steel_type"
              value={formData.steel_type}
              onChange={(e) => handleInputChange("steel_type", e.target.value)}
              required
              error={fieldErrors.steel_type}
              sx={{ mb: 2 }}
            />
            <Autocomplete
              fullWidth
              options={reportOptions} // Replace with actual options
              getOptionLabel={(option) => option?.name || "Seleziona un report di prelievo"}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Seleziona un report di prelievo"
                  required
                  error={fieldErrors.steel_withdrawal_report}
                />
              )}
              value={formData.steel_withdrawal_report}
              onChange={(_, newValue) => handleInputChange("steel_withdrawal_report", newValue)}
              sx={{ mb: 2 }}
            />
          </>
        )
      case 1:
        return (
          <>
            <TextField
              fullWidth
              label="Numero di campioni"
              name="number_of_samples"
              type="number"
              value={formData.number_of_samples}
              onChange={(e) => handleInputChange("number_of_samples", e.target.value)}
              required
              error={fieldErrors.number_of_samples}
              sx={{ mb: 2 }}
            />
            {formData.number_of_samples !== "" &&
              !isNaN(formData.number_of_samples) &&
              formData.samples.slice(0, formData.number_of_samples).map((sample, index) => (
                <Box key={index} sx={{ display: "flex", alignItems: "center", mb: 2, borderTop: "1px solid #ccc", pt: 2 }}>
                  <Typography variant="h6" sx={{ mr: 2 }}>Campione {index + 1}:</Typography>
                  <Box sx={{ width: "50%", display: "flex", alignItems: "center", flexDirection: "column", gap: 1 }}>
                    <TextField
                      fullWidth
                      label={`Identificazione campione`}
                      value={sample.sample_identification}
                      onChange={(e) => handleSampleInputChange(index, "sample_identification", e.target.value)}
                      required
                      error={fieldErrors[`cube_${index}_sample_identification`]}
                      variant="outlined"
                    />
                    <TextField
                      fullWidth
                      label={`Descrizione campione`}
                      value={sample.description}
                      onChange={(e) => handleSampleInputChange(index, "description", e.target.value)}
                      required
                      error={fieldErrors[`cube_${index}_description`]}
                      variant="outlined"
                    />
                    <TextField
                      fullWidth
                      label={`Diametro campione [mm]`}
                      value={sample.diameter}
                      type="number"
                      onChange={(e) => handleSampleInputChange(index, "diameter", e.target.value)}
                      required
                      error={fieldErrors[`cube_${index}_diameter`]}
                      variant="outlined"
                    />
                    <TextField
                      fullWidth
                      label={`Posizione in opera`}
                      value={sample.position}
                      onChange={(e) => handleSampleInputChange(index, "position", e.target.value)}
                      required
                      error={fieldErrors[`cube_${index}_position`]}
                      variant="outlined"
                    />
                    <TextField
                      fullWidth
                      label={`Prove richieste`}
                      value={sample.required_test}
                      onChange={(e) => handleSampleInputChange(index, "required_test", e.target.value)}
                      required
                      error={fieldErrors[`cube_${index}_required_test`]}
                      variant="outlined"
                    />

                  </Box>
                  <IconButton
                    onClick={() => handleRemoveSample(index)}
                    sx={{ ml: 1 }}
                    aria-label={`Rimuovi campione ${index + 1}`}
                  >
                    <CloseIcon />
                  </IconButton>
                </Box>
              ))}
          </>
        )
      default:
        return null
    }
  }

  return (
  <DashboardLayout>
    {authContext?.hasAuth("UPDATE_STEELWITHDRAWALREGISTRATION") ? (
      <>
        <DashboardNavbar />
        {!loading ? (
          <Paper elevation={3} sx={{p: 3, maxWidth: 900, mx: "auto", mt: 4}}>
            <center>
               <Typography variant="h5" gutterBottom>
                Registrazione prelievo acciaio
              </Typography>
              <Button
                variant="contained"
                onClick={() => navigate("/steel-withdrawal-registration-managment/")}
                sx={{
                  mb:3,
                  color: "white!important",
                }}
              >
                TORNA ALLA TABELLA
              </Button>
            </center>
            <Stepper activeStep={activeStep} sx={{mb: 4}}>
              <Step>
                <StepLabel>Informazioni generali</StepLabel>
              </Step>
              <Step>
                <StepLabel>Campioni prelevati</StepLabel>
              </Step>
            </Stepper>
            <Box component="form" noValidate autoComplete="off">
              {renderStepContent(activeStep)}
              <Box sx={{display: "flex", justifyContent: "space-between", mt: 2}}>
                <Button onClick={handleBack} disabled={activeStep === 0} sx={{color: "white!important"}}>
                  Indietro
                </Button>
                {activeStep === 1 ? (
                  <Button variant="contained" onClick={handleSubmit} sx={{color: "white!important"}}>
                    Salva
                  </Button>
                ) : (
                  <Button variant="contained" onClick={handleNext} sx={{color: "white!important"}}>
                    Avanti
                  </Button>
                )}
              </Box>
            </Box>
          </Paper>
        ) : (
          <Box sx={{display: "flex", justifyContent: "center", mt: 4}}>
            <CircularProgress size={120} sx={{color: "#2b84ea"}}/>
          </Box>
        )}
      </>
    ) : (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <Typography variant="h6">
          Non hai il permesso di modificare questa registrazione
        </Typography>
      </Box>
    )}
  </DashboardLayout>
);

}

export default ConcreteCastingRegistrationAdd
